/**
 * EasyPC Order Tracking Page — Frontend JS
 * Calls track.easypc.com.ph API to look up order tracking info.
 */
(function () {
  'use strict';

  var API_BASE = 'https://track.easypc.com.ph';

  var CARRIER_MESSAGES = {
    jt: 'Your package is being delivered by J&T Express. Click the tracking link above for real-time updates.',
    gogo: 'Your package is being delivered by Gogo Express.',
    lalamove: 'Your order is being delivered via Lalamove. Tracking is available in the Lalamove app.',
    inhouse: 'Your order is being delivered by our EasyPC rider. For delivery updates, contact us at support@easypc.com.ph or call (02) 8-364-8090.'
  };

  var SHIPMENT_STATUS_LABELS = {
    in_transit: 'In Transit',
    out_for_delivery: 'Out for Delivery',
    delivered: 'Delivered',
    label_printed: 'Label Printed',
    label_purchased: 'Label Purchased',
    attempted_delivery: 'Attempted Delivery',
    ready_for_pickup: 'Ready for Pickup',
    picked_up: 'Picked Up',
    failure: 'Delivery Failed',
    success: 'Fulfilled'
  };

  // --- Helpers ---

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    return d.toLocaleDateString('en-PH', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function formatDateTime(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    return d.toLocaleDateString('en-PH', {
      month: 'short', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: '2-digit', hour12: true
    });
  }

  function $(id) { return document.getElementById(id); }

  // --- Form Handling ---

  var form = $('track-order-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      handleTrackOrder();
    });
  }

  // Check URL params for auto-lookup
  checkUrlParams();

  function checkUrlParams() {
    var params = new URLSearchParams(window.location.search);
    var order = params.get('order') || params.get('order_number');
    var email = params.get('email');
    if (order && email) {
      var orderInput = $('order-number');
      var emailInput = $('order-email');
      if (orderInput) orderInput.value = order;
      if (emailInput) emailInput.value = email;
      handleTrackOrder();
    }
  }

  function handleTrackOrder() {
    var orderInput = $('order-number');
    var emailInput = $('order-email');
    if (!orderInput || !emailInput) return;

    var orderNumber = orderInput.value.trim().replace(/^#/, '').replace(/[^a-zA-Z0-9-]/g, '');
    var email = emailInput.value.trim();

    if (!orderNumber || !email) return;

    showLoading();
    hideError();
    hideResults();

    fetch(API_BASE + '/api/tracking/lookup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber: orderNumber, email: email })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        hideLoading();
        if (data.success) {
          renderResults(data.data);
        } else {
          showError(data.error || 'Order not found. Please check your order number and email.');
        }
      })
      .catch(function () {
        hideLoading();
        showError('Unable to look up your order. Please try again later.');
      });
  }

  // --- Show/Hide ---

  function showLoading() {
    var el = $('track-loading');
    if (el) el.classList.remove('hidden');
  }

  function hideLoading() {
    var el = $('track-loading');
    if (el) el.classList.add('hidden');
  }

  function showError(msg) {
    var el = $('track-error');
    if (el) {
      el.textContent = msg;
      el.classList.remove('hidden');
    }
  }

  function hideError() {
    var el = $('track-error');
    if (el) el.classList.add('hidden');
  }

  function hideResults() {
    var el = $('track-results');
    if (el) el.classList.add('hidden');
  }

  // --- Render Results ---

  function renderResults(data) {
    // Order summary
    var summaryEl = $('result-order-number');
    if (summaryEl) summaryEl.textContent = data.orderNumber;

    var dateEl = $('result-order-date');
    if (dateEl) dateEl.textContent = 'Ordered ' + formatDate(data.orderDate);

    var statusEl = $('result-status-badge');
    if (statusEl) {
      var status = data.fulfillmentStatus || 'unfulfilled';
      var statusLabel = status === 'fulfilled' ? 'Confirmed' : status === 'partial' ? 'Partially Confirmed' : 'Processing';
      statusEl.textContent = statusLabel;
      statusEl.className = 'status-badge ' + (status || 'unfulfilled');
    }

    // Timeline
    renderTimeline(data.timeline);

    // Fulfillment cards
    renderFulfillments(data.fulfillments);

    // Order items
    renderItems(data.items);

    // Show results
    var el = $('track-results');
    if (el) el.classList.remove('hidden');
  }

  function renderTimeline(timeline) {
    var stepsContainer = $('timeline-steps');
    var progressBar = $('timeline-progress');
    if (!stepsContainer || !progressBar) return;

    stepsContainer.innerHTML = '';

    var completedCount = 0;
    for (var i = 0; i < timeline.length; i++) {
      if (timeline[i].completed) completedCount = i + 1;
    }

    // Progress bar width: percentage based on completed steps
    var progressPercent = timeline.length > 1 ? ((completedCount - 1) / (timeline.length - 1)) * 100 : 0;
    if (progressPercent < 0) progressPercent = 0;
    progressBar.style.width = progressPercent + '%';

    for (var j = 0; j < timeline.length; j++) {
      var step = timeline[j];
      var stepDiv = document.createElement('div');
      stepDiv.className = 'timeline-step';
      if (step.completed) stepDiv.className += ' completed';
      if (step.active) stepDiv.className += ' active';

      var dotDiv = document.createElement('div');
      dotDiv.className = 'timeline-dot';
      if (step.completed) dotDiv.className += ' completed';
      if (step.active) dotDiv.className += ' active';

      if (step.completed) {
        var check = document.createElement('span');
        check.className = 'check';
        check.textContent = '\u2713';
        dotDiv.appendChild(check);
      }

      var labelDiv = document.createElement('div');
      labelDiv.className = 'timeline-label';
      labelDiv.textContent = step.label;

      var dateDiv = document.createElement('div');
      dateDiv.className = 'timeline-date';
      dateDiv.textContent = step.date ? formatDate(step.date) : '';

      var infoWrap = document.createElement('div');
      infoWrap.appendChild(labelDiv);
      infoWrap.appendChild(dateDiv);

      stepDiv.appendChild(dotDiv);
      stepDiv.appendChild(infoWrap);
      stepsContainer.appendChild(stepDiv);
    }
  }

  function renderFulfillments(fulfillments) {
    var container = $('fulfillment-cards');
    if (!container) return;

    container.innerHTML = '';

    if (fulfillments.length === 0) {
      var msg = document.createElement('div');
      msg.className = 'carrier-message';
      msg.textContent = 'Your order is being prepared for shipping. You will receive tracking details once your package is dispatched.';
      container.appendChild(msg);
      return;
    }

    for (var i = 0; i < fulfillments.length; i++) {
      var f = fulfillments[i];
      var card = document.createElement('div');
      card.className = 'fulfillment-card';

      // Header
      var header = document.createElement('div');
      header.className = 'fulfillment-header';

      var carrierSpan = document.createElement('span');
      carrierSpan.className = 'carrier-name';
      carrierSpan.textContent = f.trackingCompany || 'Carrier';
      header.appendChild(carrierSpan);

      if (f.shipmentStatus || f.status) {
        var badge = document.createElement('span');
        var badgeStatus = f.shipmentStatus || f.status;
        badge.className = 'shipment-badge ' + (f.shipmentStatus || 'default');
        badge.textContent = SHIPMENT_STATUS_LABELS[badgeStatus] || badgeStatus;
        header.appendChild(badge);
      }

      card.appendChild(header);

      // Tracking info
      if (f.trackingNumber) {
        var trackingDiv = document.createElement('div');
        trackingDiv.className = 'tracking-info';

        var numSpan = document.createElement('span');
        numSpan.className = 'tracking-number';
        numSpan.textContent = f.trackingNumber;
        trackingDiv.appendChild(numSpan);

        if (f.trackingUrl) {
          var link = document.createElement('a');
          link.className = 'track-link';
          link.href = f.trackingUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.textContent = 'Track Package';
          trackingDiv.appendChild(link);
        }

        card.appendChild(trackingDiv);
      }

      // Carrier-specific message
      var carrierMsg = CARRIER_MESSAGES[f.carrierType];
      if (carrierMsg) {
        var msgDiv = document.createElement('div');
        msgDiv.className = 'carrier-message';
        msgDiv.textContent = carrierMsg;
        card.appendChild(msgDiv);
      }

      // Fulfillment date
      if (f.createdAt) {
        var dateP = document.createElement('p');
        dateP.style.fontSize = '0.8rem';
        dateP.style.color = '#6b7280';
        dateP.style.marginTop = '12px';
        dateP.textContent = 'Shipped on ' + formatDateTime(f.createdAt);
        card.appendChild(dateP);
      }

      container.appendChild(card);
    }
  }

  function renderItems(items) {
    var container = $('item-list');
    if (!container) return;

    container.innerHTML = '';

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var row = document.createElement('div');
      row.className = 'item-row';

      if (item.imageUrl) {
        var img = document.createElement('img');
        img.className = 'item-image';
        img.src = item.imageUrl;
        img.alt = item.title;
        img.loading = 'lazy';
        row.appendChild(img);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className = 'item-placeholder';
        placeholder.textContent = '\uD83D\uDCE6';
        row.appendChild(placeholder);
      }

      var titleSpan = document.createElement('span');
      titleSpan.className = 'item-title';
      titleSpan.textContent = item.title;
      row.appendChild(titleSpan);

      var qtySpan = document.createElement('span');
      qtySpan.className = 'item-qty';
      qtySpan.textContent = 'x' + item.quantity;
      row.appendChild(qtySpan);

      container.appendChild(row);
    }
  }
})();
